import {createAsyncThunk, createSlice, PayloadAction,UnknownAction} from "@reduxjs/toolkit";
import axios from 'axios';

import {RootState} from './rootReducer'
import {persistReducer} from "redux-persist";
import storageSession from 'redux-persist/lib/storage/session';
import {closeBackdrop, openBackdrop} from "./backdrop";
import {openNotifier} from "./notifier";
const apiUrl = process.env.REACT_APP_API_URL;

export interface IVehicle {
    idAvailability:number,
    idVehiculo:number
    idTiposVehiculo:number,
    strPlaca:string,
    intEstado?:number
    strName?:string,
    idMarca:number,
    strModelo:string,
    strEconomico:string,
    strMotor:string,
    strSerie:string,
    txtComentario:string

}


interface IVehicleState {
    vehicle:IVehicle,
    vehicles:IVehicle[],
    typeVehicles:ITypeVehicle[],
    brandVehicles:IBrandVehicle[],
    typeVehiclesBrand:ITypeVehicleBrand[],
    availabilityVehicles:IAvailabilityVehicle[]
    loading:boolean,
    meta: {
        current_page: number,
        per_page:string,
        total: number
    },
    loadingEdit:boolean,
    loadingVehiclesBrands:boolean,
    loadingVehiclesType:boolean,
}
export interface ITypeVehicle {
    id:number,
    name:string
}
export interface IAvailabilityVehicle {
    id:number,
    name:string
}
export interface IBrandVehicle {
    id:number,
    name:string
}
export interface ITypeVehicleBrand {
    idVehiculo:number,
    strName:string,
    strMarca:string,
    idTiposVehiculo?:number
}
export interface ITypeVehicleSelect {
    idVehiculo:number[],
    strName:string,
    strMarca:string,
    idTiposVehiculo?:number
}
export const initialState: IVehicleState = {
    vehicle:{
        idAvailability:0,
        idVehiculo:0,
        idTiposVehiculo:0,
        strPlaca:'',
        idMarca:0,
        strModelo:'',
        strEconomico:'',
        strMotor:'',
        strSerie:'',
        txtComentario:''
    },
    meta: {
        current_page: 1,
        per_page: '10',
        total: 0
    },
    vehicles:[],

    availabilityVehicles:[{id:1,name:"status 1"},{id:2,name:"status 2"},{id:3,name:"status 3"}],
    brandVehicles:[],
    typeVehiclesBrand:[],
    typeVehicles:[],
    loadingVehiclesBrands:false,
    loadingVehiclesType:false,
    loadingEdit:false,
    loading:false
};
export const addVehicle = createAsyncThunk<string,
    { vehicle: IVehicle},
    {
        rejectValue: unknown
    }>(
    'cart/addVehicle',
    async (data, thunkApi) => {
        thunkApi.dispatch(openBackdrop())

        try {
            const response = await axios.post(`${apiUrl}/vehicles`, data.vehicle);

            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            thunkApi.dispatch(resetVehicle());
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
           thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {

            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const getVehicle = createAsyncThunk<IVehicle,
    { id: string},
    {
        rejectValue: unknown
    }>(
    'cart/getVehicle',
    async ({id}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.get(`${apiUrl}/vehicles/show/${id}`);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)

export const updateVehicle = createAsyncThunk<string,
    { id: number,vehicle:IVehicle},
    {
        rejectValue: unknown
    }>(
    'cart/updateVehicle',
    async ({id,vehicle}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.put(`${apiUrl}/vehicles/update/${id}`,vehicle);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            thunkApi.dispatch(resetVehicle());
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))

            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const disabledVehicle = createAsyncThunk<string,
    { id: number,currentPage:number},
    {
        rejectValue: unknown
    }>(
    'cart/disabledVehicle',
    async ({id,currentPage}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        try {
            const response = await axios.delete(`${apiUrl}/vehicles/changeStatus/${id}`);
            thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            thunkApi.dispatch(resetVehicle());
            thunkApi.dispatch(listVehicles({page: currentPage, items: 10}))

            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const getVehicleType = createAsyncThunk<ITypeVehicle[],
    {},
    {
        rejectValue: unknown
    }>(
    'cart/getVehicleType',
    async ({}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        thunkApi.dispatch(vehicleTypeLoading(true))
        try {
            const response = await axios.get(`${apiUrl}/vehicles/getVehicleType`);
            thunkApi.dispatch(vehicleTypeLoading(false))
            // thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(vehicleTypeLoading(false))
            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)

export const getVehicleBrand = createAsyncThunk<IBrandVehicle[],
    {},
    {
        rejectValue: unknown
    }>(
    'cart/getVehicleBrand',
    async ({}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        thunkApi.dispatch(vehicleBrandLoading(true))
        try {
            const response = await axios.get(`${apiUrl}/vehicles/getVehicleBranch`);
            thunkApi.dispatch(vehicleBrandLoading(false))
            // thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(vehicleBrandLoading(false))
            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const listVehicles = createAsyncThunk<{data:IVehicle[],
        current_page: number,
        per_page: string,
        total: number
    },
    {page: number, items: number},
    {
        rejectValue: unknown
    }>(
    'cart/listVehicles',
    async ({page,items}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())

        try {
            const response = await axios.get(`${apiUrl}/vehicles?page=${page}&items=${items}`);
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());

            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)
export const getVehicleTypeBrand = createAsyncThunk<ITypeVehicleBrand[],
    {idTipoVehiculo?:number,idMarca?:number,idEmpresa?:number},
    {
        rejectValue: unknown
    }>(
    'cart/getVehicleTypeBrand',
    async ({idTipoVehiculo,idEmpresa,idMarca}, thunkApi) => {
        thunkApi.dispatch(openBackdrop())
        thunkApi.dispatch(vehicleTypeLoading(true))
        try {
            const response = await axios.get(`${apiUrl}/vehicles/list?${idTipoVehiculo?'idTiposVehiculo=':''}${idTipoVehiculo?idTipoVehiculo:''}${idMarca?'&idMarca=':''}${idMarca?idMarca:''}${idEmpresa?'&idEmpresa=':''}${idEmpresa?idEmpresa:''}`);
            thunkApi.dispatch(vehicleTypeLoading(false))
            // thunkApi.dispatch(openNotifier({open:true,variant:"success",message:``}))
            //list vehicles
            //thunkApi.dispatch(listVehicles({}))
            thunkApi.dispatch(closeBackdrop());
            return  response.data;
        } catch (err) {
            thunkApi.dispatch(closeBackdrop());
            thunkApi.dispatch(vehicleTypeLoading(false))
            // @ts-ignore
            // thunkApi.dispatch(openNotifier({open:true,variant:"error",message:err?.response?.data?.message??'Ha ocurrido un error y el sistema se ha tenido que cerrar'}))
            // @ts-ignore
            return thunkApi.rejectWithValue(err.response.data)
        }
    }
)

const vehicleSlice = createSlice({
    name: 'vehicle',
    initialState,
    extraReducers: builder => {
        builder
            .addCase(addVehicle.pending, state => {
                state.loading = true
            })
            .addCase(addVehicle.fulfilled, (state, {payload}) => {
                state.loading = false
            })
            .addCase(addVehicle.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(getVehicle.pending, state => {
                state.loading = true
            })
            .addCase(getVehicle.fulfilled, (state, {payload}) => {
                state.loading = false
                state.vehicle=payload
            })
            .addCase(getVehicle.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(updateVehicle.pending, state => {
                state.loading = true
            })
            .addCase(updateVehicle.fulfilled, (state, {payload}) => {
                state.loading = false
                state.vehicle=initialState.vehicle

            })
            .addCase(updateVehicle.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(disabledVehicle.pending, state => {
                state.loading = true
            })
            .addCase(disabledVehicle.fulfilled, (state, {payload}) => {
                state.loading = false

            })
            .addCase(disabledVehicle.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(getVehicleType.pending, state => {
                state.loading = true
            })
            .addCase(getVehicleType.fulfilled, (state, {payload}) => {
                state.loading = false
                state.typeVehicles=payload

            })
            .addCase(getVehicleType.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(getVehicleBrand.pending, state => {
                state.loading = true
            })
            .addCase(getVehicleBrand.fulfilled, (state, {payload}) => {
                state.loading = false
                state.brandVehicles=payload

            })
            .addCase(getVehicleBrand.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(listVehicles.pending, state => {
                state.loading = true
            })
            .addCase(listVehicles.fulfilled, (state, {payload}) => {
                const {data} = payload
                state.meta.total=payload.total
                state.meta.current_page=payload.current_page
                state.meta.per_page=payload.per_page
                state.vehicles=data
                state.loading = false
            })
            .addCase(listVehicles.rejected, (state, action) => {
                state.loading = false
            })
            .addCase(getVehicleTypeBrand.pending, state => {
                state.loading = true
            })
            .addCase(getVehicleTypeBrand.fulfilled, (state, {payload}) => {
                state.loading = false
                state.typeVehiclesBrand=payload

            })
            .addCase(getVehicleTypeBrand.rejected, (state, action) => {
                state.loading = false
            })

    },
    reducers: {
        resetVehicle:(state)=>{
            state.vehicle=initialState.vehicle
        },

        resetTypeVehiclesBrand:(state)=>{
            state.typeVehiclesBrand=initialState.typeVehiclesBrand
        },
        vehicleLoading:(state,action: PayloadAction<boolean>)=>{
            state.loading= action.payload;
        },
        startEditLoading:(state)=>{
            state.loadingEdit=true
        },
        finishEditLoading:(state)=>{
            state.loadingEdit=false
        },
        vehicleBrandLoading:(state,action: PayloadAction<boolean>)=>{
            state.loadingVehiclesBrands= action.payload;
        },
        vehicleTypeLoading:(state,action: PayloadAction<boolean>)=>{
            state.loadingVehiclesType= action.payload;
        },
        resetVehicleState:()=>{

        }

    },
});

export const {resetVehicle,startEditLoading,
    finishEditLoading,vehicleTypeLoading,
    vehicleBrandLoading,
    vehicleLoading,resetTypeVehiclesBrand} = vehicleSlice.actions

export const VehiclesSelector = (state: RootState) => state.vehicle

export const VehicleMetaSelector = (state: RootState) => {
    return {
        meta: state.vehicle.meta,
        data: state.vehicle.data,
        loadingVehiclesPaginate: state.vehicle.loading,
    };
};







export const VehicleReducer = persistReducer({
    storage: storageSession,
    key: 'vehicle',
    whitelist: [''],
    blacklist:['']
}, vehicleSlice.reducer)
